// 发票签确
const billSignRoutes = [
  {
    path: '/billSign',
    name: 'billSign',
    meta: { title: '发票签收' },
    component: () =>
      import(/* webpackChunkName: "agreement" */ '../views/BillSign/Index'),
  },
  {
    path: '/billSign_success',
    name: 'billSign_success',
    meta: { title: '签收完成' },
    component: () =>
      import(/* webpackChunkName: "agreement" */ '../views/BillSign/Success'),
  },
];
export default billSignRoutes;
